import React from "react";
import { Icon, IconBaseProps } from "./Icon";

const ArrowDownIcon: React.FC<IconBaseProps> = props => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g className="nc-icon-wrapper">
      <path d="M12 19.5a2.3 2.3 0 0 1-1.729-.78L.46 7.568a1.847 1.847 0 0 1 2.773-2.439l8.579 9.752a.25.25 0 0 0 .376 0l8.579-9.752a1.847 1.847 0 1 1 2.773 2.439l-9.808 11.148A2.31 2.31 0 0 1 12 19.5z" />
    </g>
  </Icon>
);
export default ArrowDownIcon;
